import * as Types from '../../../../__generated__/schema';

import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAIInferenceStreamVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;

export type GetAIInferenceStream = {
  aiInferenceStream: Pick<
    Types.AIInferenceStream,
    | 'alias'
    | 'cancelled'
    | 'error'
    | 'finished'
    | 'responseText'
    | 'streamId'
    | 'userPrompt'
    | 'streamName'
  > & {
    usage?: Types.Maybe<
      Pick<
        Types.AIInferenceStreamUsage,
        | 'cacheCreationInputTokens'
        | 'cacheReadInputTokens'
        | 'durationSeconds'
        | 'inputTokens'
        | 'modelID'
        | 'outputTokens'
      >
    >;
    toolInvocations?: Types.Maybe<
      Array<
        Pick<
          Types.AIToolInvocation,
          'id' | 'toolName' | 'approvedAt' | 'rejectedAt' | 'timedOutAt' | 'metadata'
        >
      >
    >;
    riskScoreEvidence?: Types.Maybe<
      Pick<
        Types.RiskScoreEvidence,
        | 'aggregateBenignIndicatorsFormula'
        | 'aggregateBenignIndicatorsScore'
        | 'aggregateRiskyIndicatorsFormula'
        | 'aggregateRiskyIndicatorsScore'
        | 'benignThreshold'
        | 'classification'
        | 'classificationReasoning'
        | 'normalizedTotalRiskFormula'
        | 'normalizedTotalRiskScore'
        | 'riskyThreshold'
      > & {
        benignIndicators: Array<
          Pick<
            Types.RiskIndicator,
            | 'contextWeighting'
            | 'description'
            | 'evidenceConfidence'
            | 'riskScore'
            | 'temporalRelevance'
          >
        >;
        riskyIndicators: Array<
          Pick<
            Types.RiskIndicator,
            | 'contextWeighting'
            | 'description'
            | 'evidenceConfidence'
            | 'riskScore'
            | 'temporalRelevance'
          >
        >;
      }
    >;
  };
};

export const GetAIInferenceStreamDocument = gql`
  query GetAIInferenceStream($id: String!) {
    aiInferenceStream(streamId: $id) {
      alias
      cancelled
      error
      finished
      responseText
      streamId
      userPrompt
      streamName
      usage {
        cacheCreationInputTokens
        cacheReadInputTokens
        durationSeconds
        inputTokens
        modelID
        outputTokens
      }
      toolInvocations {
        id
        toolName
        approvedAt
        rejectedAt
        timedOutAt
        metadata
      }
      riskScoreEvidence {
        aggregateBenignIndicatorsFormula
        aggregateBenignIndicatorsScore
        aggregateRiskyIndicatorsFormula
        aggregateRiskyIndicatorsScore
        benignIndicators {
          contextWeighting
          description
          evidenceConfidence
          riskScore
          temporalRelevance
        }
        benignThreshold
        classification
        classificationReasoning
        normalizedTotalRiskFormula
        normalizedTotalRiskScore
        riskyIndicators {
          contextWeighting
          description
          evidenceConfidence
          riskScore
          temporalRelevance
        }
        riskyThreshold
      }
    }
  }
`;

/**
 * __useGetAIInferenceStream__
 *
 * To run a query within a React component, call `useGetAIInferenceStream` and pass it any options that fit your needs.
 * When your component renders, `useGetAIInferenceStream` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAIInferenceStream({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAIInferenceStream(
  baseOptions: Apollo.QueryHookOptions<GetAIInferenceStream, GetAIInferenceStreamVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAIInferenceStream, GetAIInferenceStreamVariables>(
    GetAIInferenceStreamDocument,
    options,
  );
}
export function useGetAIInferenceStreamLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAIInferenceStream, GetAIInferenceStreamVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAIInferenceStream, GetAIInferenceStreamVariables>(
    GetAIInferenceStreamDocument,
    options,
  );
}
export function useGetAIInferenceStreamSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAIInferenceStream,
    GetAIInferenceStreamVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAIInferenceStream, GetAIInferenceStreamVariables>(
    GetAIInferenceStreamDocument,
    options,
  );
}
export type GetAIInferenceStreamHookResult = ReturnType<typeof useGetAIInferenceStream>;
export type GetAIInferenceStreamLazyQueryHookResult = ReturnType<
  typeof useGetAIInferenceStreamLazyQuery
>;
export type GetAIInferenceStreamSuspenseQueryHookResult = ReturnType<
  typeof useGetAIInferenceStreamSuspenseQuery
>;
export type GetAIInferenceStreamQueryResult = Apollo.QueryResult<
  GetAIInferenceStream,
  GetAIInferenceStreamVariables
>;
export function mockGetAIInferenceStream({
  data,
  variables,
  errors,
}: {
  data: GetAIInferenceStream;
  variables?: GetAIInferenceStreamVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: GetAIInferenceStreamDocument, variables },
    result: { data, errors },
  };
}
